module.exports = __webpack_public_path__ + "static/leslie-resume-a19d62e7223f001dbec2c235cceab33c.pdf";